import { AddressElement, PaymentElement } from '@stripe/react-stripe-js';
import React from 'react';
import PropTypes from 'prop-types';
import { FormRow } from '../../../react/form_row.jsx';

export const StripePaymentRow = ({
  name,
  errors,
  showAddress = true,
  initialBillingAddress,
  onNameChange,
  onAddressChange,
}) => {
  const paymentElementOptions = {
    wallets: {
      applePay: 'never',
      googlePay: 'never',
      link: 'never',
    },
  };

  const addressElementOptions = {
    mode: 'billing',
    allowedCountries: ['US'],
    defaultValues: {
      name: name,
      address: initialBillingAddress || {},
    },
  };

  const handleAddressChange = (event) => {
    // This is enough to apply the form update the same way as a normal input change
    onNameChange?.({
      target: {
        name: 'name',
        value: event.value.name,
      },
    });

    if (event.complete === true) {
      onAddressChange?.(event.value.address);
    }
  }

  return (
    <FormRow className="payment_class payment_stripe">
      {showAddress && <AddressElement
        onChange={handleAddressChange}
        options={addressElementOptions}
      />}
      <PaymentElement
        options={paymentElementOptions}
      />
      {errors && (
        <p className="error_marker" role="alert">
          {errors}
        </p>
      )}
    </FormRow>
  );
}

StripePaymentRow.propTypes = {
  name: PropTypes.string,
  onNameChange: PropTypes.func,
  errors: PropTypes.string,
  showAddress: PropTypes.bool,
};
